import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from '@shared/components/button/button.module';
import { DirectivesModule } from '@shared/directives/directives.module';

import { RadioWrapperComponent } from './radio-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DirectivesModule
  ],
  declarations: [
    RadioWrapperComponent
  ],
  exports: [
    RadioWrapperComponent
  ]
})
export class RadioWrapperModule { }
